import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Crop32Icon(props: IconProps) {
    return <Icon {...props} iconKey={"crop_3_2"}/>
}
